<div class="panel panel-default">
    <div class="panel-heading">
        Capacity Report
    </div>
    <div class="panel-body">
        <div class="form-horizontal" [formGroup]="rootForm">
            <div class="form-group" [class.has-error]="plantingDateRangeFormControl.invalid">
                <label class="control-label col-sm-4 col-md-2">Planting Date Range</label>
                <div class="col-sm-3">
                    <input 
                        type="text" 
                        class="form-control"
                        bsDaterangepicker
                        ce-date-range-picker
                        [formControl]="plantingDateRangeFormControl"
                        #plantingDateRangePicker="bsDaterangepicker" 
                    />
                </div>
                <i 
                    class="fa fa-calendar fa-2x" 
                    aria-hidden="true" 
                    (click)="plantingDateRangePicker.show()"
                >
                </i>
            </div>
        </div>

        <div class="col-sm-offset-4 col-md-offset-2 col-sm-8">
            <button 
                type="button" 
                class="btn btn-primary pull-right" 
                [disabled]="rootForm.invalid" 
                (click)="generateReport()"
            >
                Get Report
            </button>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/capacity-report-form/capacity-report-form.component.html